import React from "react";
import { StandardButton } from "@/components/common/StandardButton";

interface LoginWithButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  iconSrc: string;
}

function LoginWithButton({ iconSrc, ...otherProps }: LoginWithButtonProps) {
  return (
    <StandardButton
      variant="loginbutton"
      className="w-full flex items-center gap-2 px-4 py-3"
      imageSrc={iconSrc}
      imageAlt=""
      size="xlg"
      {...otherProps}
    >
      <span className="text-fg-neutral-strong title-s-semibold whitespace-normal break-words">
        {otherProps.children}
      </span>
    </StandardButton>
  );
}

export default LoginWithButton;
